import { PeopleBadgeList } from '@/routes/_layout/scheduling/student-groups/-components/people-badge-list.js';
import { getSessionSubstitutionRequestSummary } from '@airreading/common';
import { AdminSession, SubstitutionRequestOrigin, SubstitutionRequestStatus } from '@airreading/common/data';
import { Temporal } from 'temporal-polyfill';

interface SessionTeacherDisplayProps {
  session: AdminSession;
  testId?: string;
}

export function isSessionTeacherPendingSubstitute(session: AdminSession): boolean {
  const {
    mostRecentRequest: summaryMostRecentRequest,
    mostRecentCoachRequest,
    mostRecentAdminRequest,
    mostRecentTNS,
  } = getSessionSubstitutionRequestSummary(session);

  const mostRecentRequest = (() => {
    if (mostRecentCoachRequest?.origin === SubstitutionRequestOrigin.automatic_conflict && mostRecentAdminRequest) {
      const coachIsNewer =
        Temporal.Instant.compare(mostRecentCoachRequest.createdAtInstant, mostRecentAdminRequest.createdAtInstant) >= 0;
      return mostRecentTNS ?? (coachIsNewer ? mostRecentCoachRequest : mostRecentAdminRequest);
    }
    // Summary prefers TNS over coach requests; a newer pending coach request should still show as pending here.
    if (
      mostRecentCoachRequest?.status === SubstitutionRequestStatus.pending &&
      mostRecentTNS?.status === SubstitutionRequestStatus.fulfilled &&
      Temporal.Instant.compare(mostRecentCoachRequest.createdAtInstant, mostRecentTNS.createdAtInstant) > 0
    ) {
      return mostRecentCoachRequest;
    }
    return summaryMostRecentRequest;
  })();

  return mostRecentRequest?.status === SubstitutionRequestStatus.pending;
}

export const SessionTeacherDisplay = ({ session, testId }: SessionTeacherDisplayProps) => {
  const { substituteCoach, coach } = session;

  if (isSessionTeacherPendingSubstitute(session)) {
    return <span data-testid={testId}>Pending substitute teacher</span>;
  }

  const coachToShow = substituteCoach || coach;
  if (!coachToShow) {
    return <span data-testid={testId}>-</span>;
  }

  return <PeopleBadgeList people={[coachToShow]} testId={testId} />;
};
